<template>
    <base-container :isLoading="isLoading">
        <!-- <van-nav-bar title="当日挂号" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
        <div class="registration">
            <div class="emparty_schedule" v-if="isDisplayNoDoctor">
                <van-empty class="custom-image"  image="../../../images/02.png"
                    description="暂无医生" />
            </div>
            <div v-if="!isDisplayNoDoctor&&doctorLists.length>0">
                <section v-for="(doctor,index) in doctorLists" :key="index">
                    <header class="radius">
                        <div class="doctor">
                            <div class="doctor_avator"><img src="@/assets/img/doctor_avator.png" alt="" /></div>
                            <div class="doctor_detail" v-if="noType=='0'">
                                <div class="name"><span class="doctor_name">{{doctor.doctorTitle}}</span> <span
                                        class="doctor_type">{{doctor.deptName}}</span></div>
                                <div class="title"><span class="zc">{{doctor.visitDate}}／{{doctor.visitWeek}}</span>
                                </div>
                            </div>
                            <div class="doctor_detail" v-if="noType=='2'">
                                <div class="name"><span class="doctor_name">{{doctor.doctorName}}</span> <span
                                        class="doctor_type">专家号</span></div>
                                <div class="title"><span class="zc">{{doctor.doctorTitle}}／{{doctor.deptName}}</span>
                                </div>
                                <div class="title"><span class="zc">{{doctor.visitDate}}／{{doctor.visitWeek}}</span>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="source_num radius">
                        <div class="residue_source" v-for="(numTime,index) in doctor.numTimeList" :key="index">
                            <div class="num">{{numTime.regLeaveCount}}</div>
                            <div class="register_fee">
                                <p>{{numTime.startTime}}-{{numTime.endTime}}</p>
                                <p style="margin-top: 0.5rem;">挂号费<span>¥{{doctor.registerFee}}</span>
                                </p>
                            </div>
                            <div class="appoint" style="width: auto;" @click="selDoctor(doctor,numTime)">
                                <span>立即挂号</span></div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </base-container>
</template>

<script>
    import "@/assets/css/reset.css";
    import "@/assets/css/comman.css";
    import "@/assets/css/AppointmentDetail.css";
    import "@/assets/css/registrationOnDay.css";
    import { GetRegisterDoctorNumList } from "@/api/hos";

    export default {
        props: ["noType", "orgCode", "deptCode"],
        data() {
            return {
                isLoading: false,
                isDisplayNoDoctor: false,
                regDateList: [],
                checkDateTime: "",
                queryParams: {
                    OrgCode: undefined,
                    DeptCode: undefined,
                    ReserveDate: undefined
                },
                doctorLists: []
            };
        },
        created() {
            this.GetRegisterDoctorNumList();
        },
        methods: {
            GetRegisterDoctorNumList() {
                this.doctorLists = [];
                this.isLoading = true;
                this.isDisplayNoDoctor = false;
                var dataGetRegisterDoctorNumList = {
                    OrgCode: this.orgCode,
                    DeptCode: this.deptCode,
                    NoType: this.noType
                };
                GetRegisterDoctorNumList(dataGetRegisterDoctorNumList).then(res => {
                    //console.log(res.data.value);
                    if (res.data.value.length > 0) {
                        this.doctorLists = res.data.value;
                    }
                    else {
                        this.isDisplayNoDoctor = true;
                    }
                    this.isLoading = false;
                }).catch(() => {
                    this.isDisplayNoDoctor = true;
                    this.isLoading = false;
                });
            },
            selDoctor(doctor, numTime) {
                this.toPage("hosregisterconfirmation", {
                    noType: this.noType,
                    orgCode: this.orgCode,
                    deptCode: this.deptCode,
                    deptName: doctor.deptName,
                    doctorName: doctor.doctorName,
                    doctorCode: doctor.doctorCode,
                    registerFee: doctor.registerFee,
                    visitDate: doctor.visitDate,
                    visitWeek: doctor.visitWeek,
                    visitTimeFlag: doctor.visitTimeFlag,
                    regFee: doctor.regFee,
                    treatFee: doctor.treatFee,
                    resRegAmount: doctor.registerFee,
                    startTime: numTime.startTime,
                    endTime: numTime.endTime
                });
            },
            toPage(name, params) {
                this.$router.push({ name, params });
            }
        }
    };
</script>
<style>
    .custom-image .van-empty__image {
        width: 90px;
        height: 58px;
    }
</style>